var _style, _g, _path, _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _line, _line2, _path2, _path3, _defs8, _g2, _defs9, _line3, _line4, _path4, _path5, _defs10, _g3, _defs11, _line5, _line6, _path6, _g4, _defs12, _g5, _g6, _path7, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRai(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-163 -110 631.8 629",
    style: {
      enableBackground: "new -163 -110 631.8 629"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#192123;}\r\n\t.st1{opacity:0.7;}\r\n\t.st2{fill:url(#SVGID_1_);}\r\n\t.st3{clip-path:url(#SVGID_5_);}\r\n\t.st4{clip-path:url(#SVGID_9_);}\r\n\t.st5{opacity:0.5;clip-path:url(#SVGID_15_);fill:none;stroke:#FFFFFF;stroke-width:26.7624;stroke-miterlimit:10;}\r\n\t.st6{opacity:0.5;clip-path:url(#SVGID_15_);fill:none;stroke:#FFFFFF;stroke-width:13.3812;stroke-miterlimit:10;}\r\n\t.st7{fill:#FFFFFF;}\r\n\t.st8{clip-path:url(#SVGID_17_);}\r\n\t.st9{fill:#19898A;}\r\n\t.st10{fill:#68FEE2;}\r\n\t.st11{fill:#1FC9A8;}\r\n\t.st12{opacity:0.6;clip-path:url(#SVGID_19_);fill:none;stroke:#FFFFFF;stroke-width:26.7624;stroke-miterlimit:10;}\r\n\t.st13{opacity:0.6;clip-path:url(#SVGID_19_);fill:none;stroke:#FFFFFF;stroke-width:13.3812;stroke-miterlimit:10;}\r\n\t.st14{clip-path:url(#SVGID_17_);fill:#FFFFFF;}\r\n\t.st15{clip-path:url(#SVGID_21_);}\r\n\t.st16{fill:#3AC1AC;}\r\n\t.st17{opacity:0.5;clip-path:url(#SVGID_23_);fill:none;stroke:#FFFFFF;stroke-width:26.7624;stroke-miterlimit:10;}\r\n\t.st18{opacity:0.5;clip-path:url(#SVGID_23_);fill:none;stroke:#FFFFFF;stroke-width:13.3812;stroke-miterlimit:10;}\r\n\t.st19{clip-path:url(#SVGID_21_);fill:#FFFFFF;}\r\n\t.st20{opacity:0.6;clip-path:url(#SVGID_25_);}\r\n\t.st21{fill:none;stroke:#FFFFFF;stroke-width:22.5264;stroke-miterlimit:10;}\r\n\t.st22{fill:none;stroke:#FFFFFF;stroke-width:15.0176;stroke-miterlimit:10;}\r\n\t.st23{clip-path:url(#SVGID_29_);}\r\n\t.st24{clip-path:url(#SVGID_33_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 152.9,
    cy: 204.5,
    r: 300.8
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st1"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4556,
    y1: -56.0773,
    x2: 303.3444,
    y2: 465.0773
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0007887628,
    style: {
      stopColor: "#2F353D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1394,
    style: {
      stopColor: "#314348"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4008,
    style: {
      stopColor: "#376864"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7542,
    style: {
      stopColor: "#41A291"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#48CFB4"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M152.9-73c36.1,0,71.2,6.8,104.4,20.3c34.4,14,65.3,34.5,91.8,61c26.5,26.5,47,57.4,61,91.8 c13.5,33.2,20.3,68.4,20.3,104.4s-6.8,71.2-20.3,104.4c-14,34.4-34.5,65.3-61,91.8c-26.5,26.5-57.4,47-91.8,61 C224.1,475.2,189,482,152.9,482s-71.2-6.8-104.4-20.3c-34.4-14-65.3-34.5-91.8-61c-26.5-26.5-47-57.4-61-91.8 c-13.5-33.2-20.3-68.4-20.3-104.4s6.8-71.2,20.3-104.4c14-34.4,34.5-65.3,61-91.8c26.5-26.5,57.4-47,91.8-61 C81.7-66.2,116.8-73,152.9-73 M152.9-96.3c-77,0-154,29.4-212.7,88.1c-117.5,117.5-117.5,307.9,0,425.4 c58.7,58.7,135.7,88.1,212.7,88.1s154-29.4,212.7-88.1c117.5-117.5,117.5-307.9,0-425.4C306.9-66.9,229.9-96.3,152.9-96.3 L152.9-96.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_2_",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_3_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_2_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_4_",
    d: "M87.7,271.6L207,92.4c1-1.6,1.8-3.3,2.3-5.1l8.9-36.3c3.5-14.2-11.9-25.4-24.4-17.8L34.3,131.1 c-3.3,2-5.8,5.1-7,8.8l-10.8,32.8c-1.3,4.1-1,8.5,0.9,12.3l42,84.8C65.1,281.1,80.8,282.1,87.7,271.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_5_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_4_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st3"
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_6_",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_7_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_6_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_8_",
    d: "M112,375.9L271.5,278c3.3-2,5.8-5.1,7-8.8l10.8-32.8c1.3-4.1,1-8.5-0.9-12.3l-42-84.8 c-5.6-11.3-21.2-12.3-28.2-1.8L98.8,316.7c-1,1.6-1.8,3.3-2.3,5.1l-8.9,36.3C84.2,372.3,99.6,383.5,112,375.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_9_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_8_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_10_",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_11_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_10_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st4"
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_12_",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_13_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_12_",
    style: {
      overflow: "visible"
    }
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_14_",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_15_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_14_",
    style: {
      overflow: "visible"
    }
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 202,
    y1: 173.9,
    x2: -5.4,
    y2: 276.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 227.6,
    y1: 117.2,
    x2: 20.2,
    y2: 219.7
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M62.9,124.6c1.9,1.9,5.4,11.7,5.4,11.7s3-9.2,5.4-11.7c2.4-2.5,11.7-5.4,11.7-5.4s-9.6-3.3-11.7-5.4 c-2.1-2.1-5.4-11.7-5.4-11.7s-3.1,9.4-5.4,11.7c-2.3,2.3-11.7,5.4-11.7,5.4S60.9,122.6,62.9,124.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M126,136.6c0.9,0.9,2.4,5.3,2.4,5.3s1.3-4.2,2.4-5.3c1.1-1.1,5.3-2.4,5.3-2.4s-4.3-1.5-5.3-2.4 c-1-1-2.4-5.3-2.4-5.3s-1.4,4.2-2.4,5.3s-5.3,2.4-5.3,2.4S125.1,135.8,126,136.6z"
  })), /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_16_",
    d: "M87.7,271.6L207,92.4c1-1.6,1.8-3.3,2.3-5.1l8.9-36.3c3.5-14.2-11.9-25.4-24.4-17.8L34.3,131.1 c-3.3,2-5.8,5.1-7,8.8l-10.8,32.8c-1.3,4.1-1,8.5,0.9,12.3l42,84.8C65.1,281.1,80.8,282.1,87.7,271.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_17_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_16_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "227.6,12.4 29.2,134.2 180.3,98.5  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "180.3,98.5 180.3,98.5 72.1,295.2 208.5,90 227.6,12.4 180.3,98.5  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "72.1,295.2 29.2,134.2 14.5,179  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_18_",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_19_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_18_",
    style: {
      overflow: "visible"
    }
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st12",
    x1: 130.4,
    y1: 248.6,
    x2: 76.8,
    y2: 23.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st13",
    x1: 180,
    y1: 286.2,
    x2: 126.5,
    y2: 61.1
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M62.9,124.6c1.9,1.9,5.4,11.7,5.4,11.7s3-9.2,5.4-11.7c2.4-2.5,11.7-5.4,11.7-5.4s-9.6-3.3-11.7-5.4 c-2.1-2.1-5.4-11.7-5.4-11.7s-3.1,9.4-5.4,11.7c-2.3,2.3-11.7,5.4-11.7,5.4S60.9,122.6,62.9,124.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M126,136.6c0.9,0.9,2.4,5.3,2.4,5.3s1.3-4.2,2.4-5.3c1.1-1.1,5.3-2.4,5.3-2.4s-4.3-1.5-5.3-2.4 c-1-1-2.4-5.3-2.4-5.3s-1.4,4.2-2.4,5.3s-5.3,2.4-5.3,2.4S125.1,135.8,126,136.6z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_20_",
    d: "M112,375.9L271.5,278c3.3-2,5.8-5.1,7-8.8l10.8-32.8c1.3-4.1,1-8.5-0.9-12.3l-42-84.8 c-5.6-11.3-21.2-12.3-28.2-1.8L98.8,316.7c-1,1.6-1.8,3.3-2.3,5.1l-8.9,36.3C84.2,372.3,99.6,383.5,112,375.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_21_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_20_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.2,396.7 276.6,274.9 125.5,310.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "125.5,310.6 125.5,310.6 233.7,114 97.3,319.1 78.2,396.7 125.5,310.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st16",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "233.7,114 276.6,274.9 291.3,230.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_22_",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_23_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_22_",
    style: {
      overflow: "visible"
    }
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st17",
    x1: 295.2,
    y1: 291.3,
    x2: 91.9,
    y2: 180.7
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st18",
    x1: 356.3,
    y1: 279.5,
    x2: 153.1,
    y2: 169
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M179.8,308.2c-0.9-0.9-2.4-5.3-2.4-5.3s-1.3,4.2-2.4,5.3c-1.1,1.1-5.3,2.4-5.3,2.4s4.3,1.5,5.3,2.4 s2.4,5.3,2.4,5.3s1.4-4.2,2.4-5.3s5.3-2.4,5.3-2.4S180.7,309,179.8,308.2z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st9",
    points: "78.2,396.7 276.6,274.9 125.5,310.6  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "125.5,310.6 125.5,310.6 233.7,114 97.3,319.1 78.2,396.7 125.5,310.6  "
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "st11",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "233.7,114 276.6,274.9 291.3,230.1  "
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st15"
  }, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_24_",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_25_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_24_",
    style: {
      overflow: "visible"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st21",
    x1: 308.7,
    y1: 273.4,
    x2: 105.5,
    y2: 162.9
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "st20"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st22",
    x1: 369.9,
    y1: 261.7,
    x2: 166.6,
    y2: 151.1
  })))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M179.8,308.2c-0.9-0.9-2.4-5.3-2.4-5.3s-1.3,4.2-2.4,5.3c-1.1,1.1-5.3,2.4-5.3,2.4s4.3,1.5,5.3,2.4 s2.4,5.3,2.4,5.3s1.4-4.2,2.4-5.3s5.3-2.4,5.3-2.4S180.7,309,179.8,308.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_26_",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_27_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_26_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_28_",
    d: "M87.7,271.6L207,92.4c1-1.6,1.8-3.3,2.3-5.1l8.9-36.3c3.5-14.2-11.9-25.4-24.4-17.8L34.3,131.1 c-3.3,2-5.8,5.1-7,8.8l-10.8,32.8c-1.3,4.1-1,8.5,0.9,12.3l42,84.8C65.1,281.1,80.8,282.1,87.7,271.6z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_29_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_28_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st23"
  }, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_30_",
    points: "180.3,98.5 29.2,134.2 72.1,295.2  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_31_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_30_",
    style: {
      overflow: "visible"
    }
  })))), /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_32_",
    d: "M112,375.9L271.5,278c3.3-2,5.8-5.1,7-8.8l10.8-32.8c1.3-4.1,1-8.5-0.9-12.3l-42-84.8 c-5.6-11.3-21.2-12.3-28.2-1.8L98.8,316.7c-1,1.6-1.8,3.3-2.3,5.1l-8.9,36.3C84.2,372.3,99.6,383.5,112,375.9z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_33_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_32_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_34_",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_35_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_34_",
    style: {
      overflow: "visible"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    className: "st24"
  }, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "SVGID_36_",
    points: "125.5,310.6 276.6,274.9 233.7,114  "
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_37_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_36_",
    style: {
      overflow: "visible"
    }
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRai);
export default __webpack_public_path__ + "static/media/rai.1057a76c4e155544cdcf99639c55d649.svg";
export { ForwardRef as ReactComponent };